<template>
    <vx-card :title='$t("ProjectTemplates")'>
        <vs-table ref="table" v-model="selected" @selected="handleSelected" pagination :max-items="50" search :data="projectTemplates">

            <div slot="header" class="flex flex-wrap-reverse items-center flex-grow justify-between">

                <div class="flex flex-wrap-reverse items-center">
                    <vs-button v-if="$checkPermission(205)" type="border" color="success" icon-pack="feather" icon="icon-plus-circle" @click="addProjectTemplatePrompt = true">{{$t("Add")}}</vs-button>
                </div>

                <vs-dropdown vs-trigger-click class="cursor-pointer mb-4 mr-4">
                    <div class="p-4 border border-solid d-theme-border-grey-light rounded-full d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                        <span class="mr-2">{{ currentPage * itemsPerPage - (itemsPerPage - 1) }} - {{ projectTemplates.length - currentPage * itemsPerPage > 0 ? currentPage * itemsPerPage : projectTemplates.length }} of {{ projectTemplates.length }}</span>
                        <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                    </div>

                    <vs-dropdown-menu>

                        <vs-dropdown-item @click="itemsPerPage=10">
                            <span>10</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=20">
                            <span>20</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=50">
                            <span>50</span>
                        </vs-dropdown-item>
                        <vs-dropdown-item @click="itemsPerPage=100">
                            <span>100</span>
                        </vs-dropdown-item>
                    </vs-dropdown-menu>
                </vs-dropdown>
            </div>

            <template slot="thead">
                <vs-th sort-key="name">{{$t("Name")}}</vs-th>
                <vs-th sort-key="description">{{$t("Description")}}</vs-th>
            </template>

            <template slot-scope="{data}">
                <tbody>
                <vs-tr :data="tr" :key="index" v-for="(tr, index) in data">

                    <vs-td :data="data[index].name">
                        {{ data[index].name }}
                    </vs-td>

                    <vs-td :data="data[index].description">
                        {{ data[index].description }}
                    </vs-td>

                </vs-tr>
                </tbody>
            </template>

        </vs-table>

        <vs-popup :title="$t('Add')" :active.sync="addProjectTemplatePrompt">
            <div>
                <p class="mt-6">{{$t("Name")}}</p>
                <vs-input v-model="projectTemplateAdding['name']" style="width: 100%"></vs-input>
                <p class="mt-6">{{$t("Description")}}</p>
                <vs-textarea v-model="projectTemplateAdding['description']" class="w-full" />
                <vs-divider/>
                <vs-button color="success" type="border" class="mt-6; mr-1" @click="addProjectTemplate">{{$t("Add")}}</vs-button>
            </div>
        </vs-popup>

    </vx-card>
</template>
<script>

    export default {
        data() {
            return {
                selected: {},
                projectTemplates: [],

                itemsPerPage: 20,
                isMounted: false,

                addProjectTemplatePrompt: false,

                projectTemplateAdding: {},

            }
        },
        computed: {
            currentPage() {
                if(this.isMounted) {
                    return this.$refs.table.currentx
                }
                return 0
            },
        },
        methods: {
            handleSelected(tr) {
                this.$router.push({ name: 'projectTemplate', params: { id: tr.id } })
            },
            updateProjectTemplates() {
                const thisIns = this;
                this.$http.get('/api/v1/projectTemplate/')
                    .then(function (response) {
                        thisIns.projectTemplates = response.data;
                    })
                    .catch(function (error) {
                        thisIns.$vs.notify({
                            title:'Error',
                            text: error,
                            color:'danger',
                            iconPack: 'feather',
                            icon:'icon-alert-circle'})
                    });
            },
            addProjectTemplate() {
                const thisIns = this;
                this.$http.post('/api/v1/projectTemplate/', this.projectTemplateAdding)
                    .then(function () {
                        thisIns.addProjectTemplatePrompt = false;
                        thisIns.updateProjectTemplates();
                        thisIns.projectTemplateAdding = {}
                    }).catch(function (error) {
                    thisIns.addProjectTemplatePrompt = false;
                    thisIns.$vs.notify({
                        title:'Error',
                        text: error,
                        color:'danger',
                        iconPack: 'feather',
                        icon:'icon-alert-circle'})
                });
            },
        },
        watch: {
            editProjectTemplatePrompt: function () {
                if(!this.editProjectTemplatePrompt){
                    this.selected = {}
                }
            }
        },
        created() {
            this.updateProjectTemplates()
        },
        mounted() {
            this.isMounted = true;
        },
        beforeRouteLeave (to, from, next) {
            if(this.addProjectTemplatePrompt){
                this.addProjectTemplatePrompt = false;
                next(false)
            }else{
                next()
            }
        }
    }
</script>
